/**
 * @copyright © Paramount Streaming
 * @description Identifies a registered API adapter for the Data Service plugin.
 */
export enum AdapterId {
	PLUTO = 'pluto',
	PLUTO_LEGACY = 'pluto_legacy'
}